import { MYNAVI_PRIMARY } from '../Color'

export type MyNaviParticipateButtonProps = {
  onClick: () => void
  disabled?: boolean
  /** ローディング中フラグ（GPS 取得中・近傍OC取得中・スタンプ押印 API 呼び出し中） */
  loading?: boolean
}

export const MyNaviParticipateButton = ({ onClick, disabled, loading }: MyNaviParticipateButtonProps) => {
  const isInactive = disabled || loading
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isInactive}
      aria-label="参加登録"
      style={{
        backgroundColor: isInactive ? '#cccccc' : MYNAVI_PRIMARY,
        color: '#ffffff',
        borderRadius: '50%',
        width: '68px',
        height: '68px',
        fontSize: '14px',
        fontWeight: 400,
        fontFamily: "'BIZ UDPGothic', sans-serif",
        border: 'none',
        cursor: isInactive ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        lineHeight: 1.3,
        whiteSpace: 'pre-wrap',
        boxShadow: '0 4px 8px rgba(0,0,0,0.25)',
        flexShrink: 0,
      }}
    >
      {loading ? '取得中...' : '参加\n登録'}
    </button>
  )
}
